// 根据树结构数据，查找叶子节点id对应的上层节点id
export const getTreeIds = (tree, nodeId, config) => {
    const {
        children = 'children', id = 'id'
    } = config || {}
    const toFlatArray = (tree, parentId) => {
        return tree.reduce((t, _) => {
            const child = _[children]
            return [
                ...t,
                parentId ? {
                    ..._,
                    parentId
                } : _,
                ...(child && child.length ? toFlatArray(child, _[id]) : [])
            ]
        }, [])
    }
    const getIds = flatArray => {
        let ids = [nodeId]
        let child = flatArray.find(_ => _[id] === nodeId)
        while (child && child.parentId) {
            ids = [child.parentId, ...ids]
            child = flatArray.find(_ => _[id] === child.parentId)
        }
        return ids
    }
    return getIds(toFlatArray(tree))
}
// 根据树结构数据，查找叶子节点id对应的上层节点name
export const getTreeNames = (tree, nodeId, config) => {
    const {
        children = 'children', id = 'name'
    } = config || {}
    const toFlatArray = (tree, parentId) => {
        return tree.reduce((t, _) => {
            const child = _[children]
            return [
                ...t,
                parentId ? {
                    ..._,
                    parentId
                } : _,
                ...(child && child.length ? toFlatArray(child, _[id]) : [])
            ]
        }, [])
    }
    const getIds = flatArray => {
        let ids = []
        let child = flatArray.find(_ => _['id'] === nodeId)
        while (child && child.parentId) {
            ids = [child.parentId, ...ids]
            child = flatArray.find(_ => _[id] === child.parentId)
        }
        return ids
    }
    return getIds(toFlatArray(tree))
}

// 根据树结构数据，查找叶子节点id对应的name
export const getTreeTitle = (tree, nodeId) => {
    let name = ''
    for (let index = 0; index < tree.length; index++) {
        const element = tree[index];
        if (element.id == nodeId) {
            name = element.name
            return name
        }else{
            getTreeTitle(element.children,nodeId)
        }
    }
}

//  计算时间
export function getNowDate(time) {
    var dd = new Date(time);
    var y = dd.getFullYear();
    //获取当前月份的日期，不足10补0
    var m = (dd.getMonth() + 1) < 10 ? '0' + (dd.getMonth() + 1) : (dd.getMonth() + 1);
    //获取当前几号，不足10补0
    var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
    return y + '-' + m + '-' + d;
}